import { FoodListContext } from "../context/FoodListContext";
import { useContext } from "react";

export const useFoodListContext = () => {
    const context = useContext(FoodListContext);

    if (!context) {
        return Error('useFoodListContext must be used inside an FoodListContextProvider');
    };

    return context;
};